import { Injectable } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // O loader só é pulado quando o header vem explicitamente com o valor 'true';
    // header ausente ou com valor 'false' mantém o loader visível
    const skipLoader = request.headers.get('X-Skip-Loader') === 'true';

    if (!skipLoader) {
      this.loaderService.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!skipLoader) {
          this.loaderService.hide();
        }
      }),
    );

  }
}